var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDownYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "p39m5yo2ea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.847059 0 0 0 0 0.690196 0 0 0 0 0.192157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#p39m5yo2ea)",
    transform: "translate(-86 -1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.47 5.47c.266-.267.683-.29.976-.073l.084.073L8 8.939l3.47-3.47c.266-.266.683-.29.976-.072l.084.073c.267.266.29.683.073.976l-.073.084-4 4c-.266.267-.683.29-.976.073l-.084-.073-4-4c-.293-.293-.293-.767 0-1.06z",
    transform: "translate(86 1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDownYellow);
export default __webpack_public_path__ + "static/media/ic-chevron-down-yellow.3f4e44b92aec4556a1a50b1f969a7252.svg";
export { ForwardRef as ReactComponent };